import Icon, { ComposedIconProps } from './Icon.tsx';

import url from '@assets/images/delete.svg';

const DeleteIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default DeleteIcon;
